const isMobileWebView = (): boolean => {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent || "";

  return /Android/i.test(ua) || /iPhone|iPad|iPod/i.test(ua);
};

export const isTelegramMobileWebview = () => {
  return isMobileWebView() && !!(window as any)!.TelegramWebviewProxy ||
    !!(window as any)!.TelegramWebviewProxyProto;
};